import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

export default function Curriculum() {
  const [data, setData] = useState(null);

  useEffect(() => {
    fetch("/videos.manifest.json")
      .then((r) => r.json())
      .then(setData)
      .catch(console.error);
  }, []);

  if (!data) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <p className="text-gray-600">Loading…</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-900 sm:text-5xl">
            Crucible Men
          </h1>
          <p className="mt-4 text-xl text-gray-600">
            Explore the series, drill into sessions, and watch videos right now!
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {data.series.map((s) => (
            <Link
              key={s.id}
              to={`/CMDashboard/${s.id}`}
              className="group block bg-white rounded-xl shadow-md overflow-hidden hover:shadow-xl hover:-translate-y-1 transition-all duration-300"
            >
              {s.image && (
                <img
                  src={s.image}
                  alt={s.title}
                  className="w-full h-48 object-cover"
                />
              )}
              <div className="p-6">
                <h3 className="text-2xl font-semibold text-gray-900 group-hover:text-blue-600 transition-colors duration-300">
                  {s.title}
                </h3>
                <p className="mt-2 text-gray-600">{s.description}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
